"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumber = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var isBigInt = (0, type_guard_1.is)((0, type_guard_1.bigint)());
var isNumber = (0, type_guard_1.is)((0, type_guard_1.number)());
var isString = (0, type_guard_1.is)((0, type_guard_1.string)());
var isNumberFormat = (0, type_guard_1.is)((0, type_guard_1.format)('number'));
function formatNumber(value, options) {
    var _a = options !== null && options !== void 0 ? options : {}, locale = _a.locale, formatOptions = __rest(_a, ["locale"]);
    var locales = locale === undefined ? [] : [locale];
    var formatter = new Intl.NumberFormat(locales, formatOptions);
    if (isBigInt(value) || isNumber(value)) {
        return formatter.format(value);
    }
    else if (isString(value)) {
        if (isNumberFormat(value)) {
            return formatter.format(value);
        }
        else {
            throw new type_guard_1.FunctionAssertionError('formatNumber', 1, [
                {
                    path: [0],
                    rule: 'format',
                    setting: 'number',
                    actual: value
                }
            ]);
        }
    }
    else {
        throw new type_guard_1.FunctionAssertionError('formatNumber', 1, [
            {
                path: [0],
                rule: 'type',
                setting: ['bigint', 'number'],
                actual: value
            }
        ]);
    }
}
exports.formatNumber = formatNumber;
//# sourceMappingURL=format-number.js.map